module.exports = __webpack_public_path__ + "img/57ne.13a20383.svg";